import '@ant-design/compatible/assets/index.css';
import React, { useCallback, useEffect, useMemo } from 'react';

import {
  Checkbox,
  DatePicker,
  notification,
  Popconfirm,
  Row,
  Spin,
} from 'antd';
import DF from 'DisplayFramework';

import Form, { FormInstance } from 'antd/lib/form';
import FormInput from 'components/FormInput';
import Value from 'components/Value';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataTable/DataTable';
import ButtonOperation from 'components/ButtonOperation';
import { useFormList } from 'hooks/useFormList';
import { indexBy, setValueByNamePath } from 'utils/utils2';
import ProductInput from 'pages/ProposalV3/PropDetail/ProductInput';
import InputCurrency from 'components/InputCurrency';
import DeleteButton from 'components/DeleteButton';
import ParListSelect from 'components/ParListSelect';
import TextArea from 'antd/lib/input/TextArea';
import { getLatestScoringFile } from 'services/scoring';
import { useQuery } from 'react-query';
import moment from 'moment';
import OfferInput from 'pages/Configuration/Management/ParametersFiltering/OfferInput';
import { min } from 'lodash';
import { toCurrency } from 'utils/utils';
import Text from 'antd/lib/typography/Text';
import PricingInput from 'pages/ProposalV3/PropDetail/PricingInput';
import getEnvValue from 'utils/getEnvValue';
import {
  AssetUseCriteria,
  FilteringCriteria,
  prFilteringCriteria,
} from 'services/pricing';
import UtinaCard from 'components/UtinaCard';
import _ from 'lodash';
import InputRate from 'components/InputRate';
import TpAuthorizationDetailRules from 'pages/ThirdParty/TpAuthorizationDetailRules';
import ModalControllerNV from 'components/ModalControllerNV';
import GetLabel from 'DisplayFramework/components/GetLabel';

export type TabEvAuthorizationProps = {
  objectid: number;
  object: string;
  form: FormInstance;
  entityName: string;
  setSuccessful: any;
  currcode: string;
};

const TabEvAuthorization = ({
  currcode,
  objectid,
  object,
  form,
  entityName,
  setSuccessful,
}: TabEvAuthorizationProps) => {
  const fieldName = 'authDetail';

  const initialValues = {
    authDetail: [],
    tpid: 0,
    authtype: '',
    creationdate: '',
    useridcreation: 0,
    startdate: '',
    enddate: '',
    authstatus: '',
    authstatusdate: '',
    authamount: 0,
    currcode: '',
    proctaskid: 0,
    authbookedamount: 0,
    authusedamount: 0,
    authavailableamount: 0,
    authcalculatedamount: 0,
    scoid: 0,
    authcomment: '',
    authtolerance: 0,
    authusedamountalert: 0,
    authflagtransfer: false,
  };

  const { add, remove } = useFormList(form, fieldName, {
    idKey: 'authid',
    addAsFirst: true,
  });

  const getName = useCallback(
    (name: string) => (record: any) => {
      const functions = form.getFieldValue(fieldName);
      const index = indexBy(functions, 'authid')[record.authid];
      return [fieldName, index, name];
    },
    [form]
  );

  const { data, isFetching } = useQuery(
    ['getLatestScoringFile', { entity: object, entityid: objectid }],
    () =>
      getLatestScoringFile({ entity: object, entityid: objectid }).then(
        (res) => res.data
      )
  );

  useEffect(() => {
    form.setFieldsValue({
      event: 'TabEvAuthorization',
      currcode: data?.currcode ?? currcode,
    });
  }, [form]);

  // const handleSaveRules =(authRulesDetails:any,authdetailid:any)=>{

  //   let authDetail= form.getFieldsValue().authDetail;
  //   let tpauthdetailrules= form.getFieldValue('tpauthorizationdetailrules');

  //   authDetail?.forEach((element:any )=> {
  //       element?.tpauthorizationdetailrules?.forEach((elem:any)=> {
  //       elem.tpidbeneficiary=authRulesDetails.tpidbeneficiary,
  //       elem.authmonth= authRulesDetails.authmonth,
  //       elem.authamount= authRulesDetails.authRulesDetails,
  //       elem.authtolerance=authRulesDetails.authtolerance,
  //       elem.authdetailid= authdetailid
  //     })
  //   });

  //   tpauthdetailrules= {...tpauthdetailrules}
  //   form.setFieldsValue({tpauthdetailrules:tpauthdetailrules})

  // }

  const addRow = () => {
    let authDetail = form.getFieldsValue()?.authDetail;
    let authdetailamountTotal = _.sumBy(authDetail, 'authdetailamount');
    let remainingAmount =
      form.getFieldValue('authamount') - authdetailamountTotal;
    let authid = Math.round(_.random(10000) * 10000000);
    form.setFieldsValue({ maxAmount: remainingAmount });

    if (remainingAmount === 0) {
      notification.error({
        message: 'Auth detail amount exceeds the total authorized amount.',
      });
      getamountTotal();
      setSuccessful(false);
    } else {
      const row = {
        authid: authid,
        currcode: '',
        ofrid: 0,
        ofrtype: '',
        prcode: '',
        tpid: 0,
        authdetailamount: Number(remainingAmount),
        maxAmount: Number(remainingAmount),
        tpauthorizationdetailrules: form.getFieldValue(
          'tpauthorizationdetailrules'
        ),
      };
      form.setFieldsValue({ prcode: '', offerid: '' });
      add(row);
      getamountTotal();
    }
  };

  const getamountTotal = (): any => {
    let authDetail = form.getFieldsValue()?.authDetail;
    let authdetailamountTotal = _.sumBy(authDetail, 'authdetailamount');
    let remainingAmount =
      form.getFieldValue('authamount') - authdetailamountTotal;

    if (remainingAmount === 0) {
      setSuccessful(false);
    }
    console.log(
      'getamountTotal',
      { authDetail, authdetailamountTotal },
      authDetail.length
    );
  };

  const getFilterList = (prcode: any, offerid: any): prFilteringCriteria => {
    let assetList = form?.getFieldValue('assets');

    let assetUseCriteriaList: Array<AssetUseCriteria> = [];
    let offerCriteriaList: Array<FilteringCriteria> = [];
    let ret: prFilteringCriteria;
    offerCriteriaList.push({
      critcode: 'OFFER',
      critvalue: offerid ?? '0',
    });
    offerCriteriaList.push({
      critcode: 'PRCODE',
      critvalue: prcode ?? '',
    });
    offerCriteriaList.push({
      critcode: 'TPTYPE',
      critvalue: form.getFieldValue('client')?.tptype ?? '',
    });
    offerCriteriaList.push({
      critcode: 'NETWORK',
      critvalue: form.getFieldValue('ctnetworkcode') ?? '',
    });
    offerCriteriaList.push({
      critcode: 'CLIRATING',
      critvalue: form.getFieldValue('client')?.tpsalestatus ?? '',
    });
    assetList?.forEach((a: any) => {
      offerCriteriaList.push({
        critcode: 'ASSETFAM',
        critvalue: a.assetfamily,
      });
      offerCriteriaList.push({ critcode: 'ASSETTYPE', critvalue: a.assettype });
      offerCriteriaList.push({
        critcode: 'ASSETCAT',
        critvalue: a.assetcategory,
      });

      offerCriteriaList.push({ critcode: 'POWER', critvalue: a.power ?? '' });
      // additional attributes :
      a.entityAddAttributList?.forEach((e: any) => {
        offerCriteriaList.push({
          critcode: e.attcode,
          critvalue: e.attstringvalue ?? e.attnumericvalue,
        });
      });

      if (getEnvValue('FLAG_APPLY_ASSET_USE')) {
        a.assetusereqList?.forEach((u: any) => {
          assetUseCriteriaList.push({
            assetfamily: a.assetfamily,
            assettype: a.assettype,
            assetcategory: a.assetcategory,
            catalogid: a.catalogid ?? '',
            attcode: u.attcode ?? '',
            attvalue: u.usevalue ?? '',
          });
        });
      }
    });

    ret = {
      prcode: form?.getFieldValue('flagmasterfacility')
        ? form?.getFieldValue('mfprcode')
        : form?.getFieldValue('prcode') ?? '',
      tpid: form.getFieldValue('client')?.tpid ?? 0,
      tpidbroker: form.getFieldValue('broker')?.tpid ?? 0,
      tpidmanufacturer: assetList ? assetList[0]?.tpidmanufacturer ?? 0 : 0,
      assetUseCriteria: assetUseCriteriaList,
      assetRVCriteria: [],
      offerCriteria: offerCriteriaList,
      flagApplyAssetUse: getEnvValue('FLAG_APPLY_ASSET_USE'),
      flagApplyAttributesExtendDurationValues: true,
      flagApplyAttributesExtendFirstRentalValues: true,
      flagApplyAttributesExtendRVValues: true,
      flagApplyAttributesExtendRateValues: true,
      flagApplyExtendDurationValues: true,
      flagApplyExtendFirstRentalValues: true,
      flagApplyExtendRVValues: true,
      flagApplyExtendRateValues: true,
    };
    return ret;
  };

  const columnsfv = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        dataIndex: 'prcode',
        width: 80,
        render: (value, record) => (
          <Form.Item noStyle name={getName('prcode')(record)}>
            <ProductInput
              onChange={(e) => {
                form.setFieldsValue({ prcode: e });
              }}
            />
          </Form.Item>
        ),
      },
      {
        dataIndex: 'offerid',
        width: 80,
        render: (value, record) => (
          <Form.Item shouldUpdate noStyle>
            {({ getFieldValue }) => {
              return (
                <Form.Item noStyle name={getName('offerid')(record)}>
                  <OfferInput
                    params={{
                      prcode: getFieldValue(getName('prcode')(record)),
                      mgid: Number(localStorage.getItem('mgid') ?? 1),
                    }}
                    allData
                    onSelect={(e) => {
                      //setValueByNamePath(form, getName('offerid')(record), e);
                      setValueByNamePath(form, getName('ofrid')(record), '');
                      setValueByNamePath(
                        form,
                        getName('ofrtypelabel')(record),
                        ''
                      );
                      form.setFieldsValue({ offerid: e });
                    }}
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
        ),
      },
      {
        dataIndex: 'ofrid',
        width: 80,
        render: (value, record) => (
          <Form.Item shouldUpdate noStyle>
            {({ getFieldValue }) => (
              <Form.Item noStyle name={getName('ofrid')(record)}>
                <PricingInput
                  params={{
                    catalogid: 0,
                    duration: 0,
                    filters: '',
                    filtersList: getFilterList(
                      form.getFieldValue(getName('prcode')(record)),
                      form.getFieldValue(getName('offerid')(record))
                    ),
                    finamount: 0,
                    mgid: Number(localStorage.getItem('mgid')),
                    offerid: form.getFieldValue(getName('offerid')(record)),
                    prcode: form.getFieldValue(getName('prcode')(record)),
                  }}
                  onChange={(e) => {
                    setValueByNamePath(
                      form,
                      getName('ofrtype')(record),
                      e.ofrtype
                    );
                    setValueByNamePath(
                      form,
                      getName('ofrid')(record),
                      e?.ofrid
                    );
                    // setValueByNamePath(form, getName('ofrid')(record), e.ofrid);
                  }}
                />
              </Form.Item>
            )}
          </Form.Item>
        ),
      },
      {
        dataIndex: 'ofrtype',
        width: 80,
        render: (value, record) => (
          <Form.Item noStyle name={getName('ofrtype')(record)}>
            <Value />
          </Form.Item>
        ),
      },
      {
        dataIndex: 'authdetailamount',
        width: 80,
        render: (value, record) => (
          <Form.Item noStyle name={getName('authdetailamount')(record)}>
            <InputCurrency
              max={record.maxAmount}
              currcode={localStorage.getItem('currcode') ?? ''}
              onChange={(e) => {
                form.setFieldsValue({ authdetailamount: e });
                getamountTotal();
              }}
            />
          </Form.Item>
        ),
      },
      {
        dataIndex: 'authtolerance',
        width: 50,
        render: (value, record) => (
          <Form.Item noStyle name={getName('authtolerance')(record)}>
            <InputRate style={{ width: '100%' }} />
          </Form.Item>
        ),
      },
      {
        dataIndex: 'authusedamountalert',
        width: 80,
        render: (value, record) => (
          <Form.Item noStyle name={getName('authusedamountalert')(record)}>
            <InputRate style={{ width: '100%' }} />
          </Form.Item>
        ),
      },
      {
        dataIndex: 'authriskclass',
        width: 80,
        render: (value, record) => (
          <Form.Item noStyle name={getName('authriskclass')(record)}>
            <ParListSelect parcode="ASSETRISK" />
          </Form.Item>
        ),
      },
      {
        dataIndex: 'Rules',
        render: (value, record) => {
          return (
            <ModalControllerNV
              modal={({ setVisible, visible }) => (
                <TpAuthorizationDetailRules
                  authdetailid={record.authdetailid}
                  currcode={
                    record?.currcode ?? localStorage.getItem('currcode')
                  }
                  onSave={(authRulesDetails: any[]) => {
                    // handleSaveRules(authRulesDetails,record.authdetailid);

                    setValueByNamePath(
                      form,
                      getName('tpauthorizationdetailrules')(record),
                      authRulesDetails
                    );
                    console.log(
                      'eee',
                      form.getFieldValue(
                        getName('tpauthorizationdetailrules')(record)
                      ),
                      record
                    );
                    setVisible(false);
                  }}
                  visible={visible}
                  tpid={objectid}
                  onCancel={() => setVisible(false)}
                  data={record?.tpauthorizationdetailrules}
                />
              )}
              content={({ setVisible, visible }) => (
                <a onClick={() => setVisible(true)}>
                  <GetLabel label="Add Rules" />
                </a>
              )}
            />
          );
        },
        width: 100,
      },
      {
        dataIndex: 'action',
        width: 60,
        render: (value, record) => (
          <Row>
            <Popconfirm
              title="Are you sure to delete this action?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => {
                remove(record?.authid);
                getamountTotal();
              }}
            >
              <DeleteButton onlyIcon />
            </Popconfirm>
          </Row>
        ),
      },
    ],
    [form, getamountTotal]
  );

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        ...data,
        tpid: objectid,
        currcode: data.currcode,
        scoid: data.scoid,
        authcalculatedamount: data.scoapprouvedamount,
        scoanalystopinion: data.scoanalystopinionlabel,
        authamount: min([data.scoapprouvedamount, data.scorequestedamount]),
        startdate: moment(),
        enddate: moment().add(3, 'M'),
        tpname: entityName,
      });
    }
  }, [data, entityName]);

  return (
    <DF.Provider pagcode="tabevauthorization">
      <div style={{ background: 'wihte' }}>
        <Form
          form={form}
          layout="horizontal"
          labelCol={{ span: 8 }}
          labelAlign="left"
          initialValues={initialValues}
        >
          <Spin spinning={isFetching}>
            <Row gutter={18}>
              <FormInput col md={12} name="tpname">
                <Value />
              </FormInput>
              <FormInput col md={12} name="scorequestedamount">
                <Text>
                  {toCurrency(
                    form.getFieldValue('scorequestedamount'),
                    data?.currcode ?? localStorage.getItem('currcode') ?? ''
                  )}
                </Text>
              </FormInput>
            </Row>
            <Row gutter={18} style={{ padding: 10 }}>
              <UtinaCard comcode="criditScoring" level={4} lg={23}>
                <Row gutter={30}>
                  <FormInput col md={8} name="scolabel">
                    <Value />
                  </FormInput>
                  <FormInput col md={8} name="scoscore">
                    <Value />
                  </FormInput>
                  <FormInput col md={8} name="scoreference">
                    <Value />
                  </FormInput>
                  <FormInput col md={8} name="scoanalystopinion">
                    <Value />
                  </FormInput>
                  <FormInput col md={8} name="authcalculatedamount">
                    <Text type="danger">
                      {toCurrency(
                        form.getFieldValue('authcalculatedamount'),
                        data?.currcode ?? localStorage.getItem('currcode') ?? ''
                      )}
                    </Text>
                  </FormInput>
                  <FormInput col md={8} name="sconote">
                    <Value />
                  </FormInput>
                  <FormInput
                    col
                    md={8}
                    name="authtype"
                    rules={[{ required: true }]}
                  >
                    <ParListSelect parcode="TPAUTHTYPE" />
                  </FormInput>

                  {/* --------------------------------------------------------------------------- */}

                  <FormInput
                    col
                    md={8}
                    name="startdate"
                    rules={[{ required: true }]}
                  >
                    <DatePicker />
                  </FormInput>
                  <FormInput
                    col
                    md={8}
                    name="enddate"
                    rules={[{ required: true }]}
                  >
                    <DatePicker />
                  </FormInput>
                  
                  <FormInput
                    col
                    md={8}
                    name="authamount"
                    rules={[{ required: true }]}
                  >
                    <InputCurrency
                      currcode={
                        data?.currcode ?? localStorage.getItem('currcode') ?? ''
                      }
                    />
                  </FormInput>
                  
                  <FormInput col md={8} name="authtolerance">
                    <InputRate />
                  </FormInput>
                  <Form.Item style={{ display: 'none' }}>
                    <FormInput col md={8} name="scoid">
                      <Value />
                    </FormInput>
                  </Form.Item>
                  <Form.Item style={{ display: 'none' }}>
                    <FormInput col md={8} name="currcode">
                      <Value />
                    </FormInput>
                  </Form.Item>
                  <FormInput col md={8} name="authusedamountalert">
                    <InputRate />
                  </FormInput>
                  <FormInput col md={8} name="authflagtransfer">
                    <Checkbox />
                  </FormInput>
                </Row>
              </UtinaCard>
              <UtinaCard comcode="authdetailList" level={4} lg={23}>
                <Form.Item noStyle shouldUpdate>
                  {({ getFieldValue }) => {
                    const actions: any[] = getFieldValue(fieldName);
                    if (
                      actions &&
                      actions.length > 0 &&
                      getFieldValue('prcode') &&
                      getFieldValue('offerid') &&
                      form.getFieldValue('authamount') -
                        _.sumBy(
                          form.getFieldsValue()?.authDetail,
                          'authdetailamount'
                        ) ===
                        0
                    ) {
                      setSuccessful(false);
                    } else {
                      setSuccessful(true);
                    }
                    return (
                      <DataGrid
                        rowKey="authid"
                        dataSource={actions}
                        columns={columnsfv.filter(
                          (e) => e.dataIndex !== 'ofrtype'
                        )}
                        titleComcode="config"
                        hideFilters
                        pagination={false}
                        extraActions={
                          <ButtonOperation
                            type="primary"
                            comcode="add"
                            onClick={() => {
                              addRow();
                            }}
                            disabled={
                              !getFieldValue('authtype') ||
                              !getFieldValue('authamount') ||
                              !getFieldValue('startdate') ||
                              !getFieldValue('enddate')
                            }
                          />
                        }
                      />
                    );
                  }}
                </Form.Item>

                <Row style={{ marginTop: 10 }}>
                  <FormInput
                    labelCol={{ span: 24 }}
                    col
                    md={24}
                    name="authcomment"
                  >
                    <TextArea rows={5} />
                  </FormInput>
                </Row>
              </UtinaCard>
            </Row>
          </Spin>
        </Form>
      </div>
    </DF.Provider>
  );
};
export default TabEvAuthorization;
